import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { advisory } from '../data/site';
export function Advisory() {
  return <>
      <PageHeader eyebrow="Advisory & Board" title="Three ways organizations engage." description="Selective engagements with boards, funds, and executive teams where clinical credibility and commercial judgment are both required." data-id="element-119" data-mp="26m4ev4ry7xbb" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-120" data-mp="2km5dseonkuo5">
        <div className="mx-auto grid max-w-7xl gap-8 px-6 lg:grid-cols-3 lg:px-10" data-id="element-121" data-mp="2kkkigmuil7p8">
          {advisory.map((item, i) => <motion.article key={item.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.09
        }} className="flex flex-col border border-stone bg-white p-8 transition-colors hover:border-ink-950 lg:p-10" data-id="element-122" data-mp="2ucgr2ru88g7p" data-mpi={i}>
              <span className="font-display text-sm text-brass-500" data-id="element-123" data-mp="3uirhkzktm8qu">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h2 className="mt-4 font-display text-xl leading-snug text-ink-950" data-id="element-124" data-mp="3pk6ij3hb1v3z">
                {item.title}
              </h2>
              <p className="mt-3 text-[15px] leading-relaxed text-graphite" data-id="element-125" data-mp="3ljw9tj24oqlf">
                {item.body}
              </p>
              <ul className="mt-6 space-y-3 border-t border-stone pt-6" data-id="element-126" data-mp="h3v83ynsahi6">
                {item.points.map(point => <li key={point} className="flex items-start gap-3 text-[14px] text-ink-900" data-id="element-127" data-mp="cc3e1e5f5tna">
                    <CheckIcon size={16} className="mt-0.5 shrink-0 text-brass-500" aria-hidden="true" data-id="element-128" data-mp="89gtzzezpd0n" />
                    {point}
                  </li>)}
              </ul>
            </motion.article>)}
        </div>
      </section>
    </>;
}